// In html use <%= react_component('ComponentName', props_hash) %>.
// Create components in app/javascript/<namespace>.
// Register components here.

import React from "react";
import ReactDOM from "react-dom";

// React Components
import VideoPlayer from "../video_player/index";
import OrderFormContainer from "../order_form/index";
import ClipboardButton from "../clipboard_button/index";
import InstitutionsNotParticipatingReport from "../admin_reports/institutions_not_participating";

const RegisteredComponentTypes = {
  VideoPlayer: VideoPlayer,
  OrderFormContainer: OrderFormContainer,
  ClipboardButton: ClipboardButton,
  InstitutionsNotParticipatingReport: InstitutionsNotParticipatingReport
};

const extractProps = el => JSON.parse(el.getAttribute("data-react-props"));

const mountComponent = function(ComponentType, node) {
  const props = extractProps(node);
  const element = <ComponentType {...props} />;
  ReactDOM.render(element, node);
};

export default function() {
  Array.prototype.forEach.call(document.querySelectorAll("[data-component-name]"), function(el){
    const componentName = el.getAttribute("data-component-name");
    const type = RegisteredComponentTypes[componentName];
    mountComponent(type, el);
  });
}
